import { createClient } from '@supabase/supabase-js';

// env 変数名は両対応にする: 公式は VITE_SUPABASE_*、他アプリ(teach/word-pool等)は
// VITE_PUBLIC_SUPABASE_* を使っており、Vercel でどちらの名前を入れても動くようにする。
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.VITE_PUBLIC_SUPABASE_URL) as string | undefined;
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY) as string | undefined;

// env が正しく設定されているか。Supabase を使う画面（/register, /services の編集, /admin）
// から参照して、未設定時にユーザへ分かりやすく案内するために公開する。
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  // 重要: ここで throw すると、ルートが静的 import されている関係で home を含む全ページの
  // バンドル評価が初期化中にクラッシュし、React がマウントできず画面が真っ白になる。
  // そのため起動は止めず、警告のみ出してダミー値でクライアントを生成する。
  // env が正しく設定されていれば従来どおり本物の値で動作する（本番では env 設定が前提）。
  // 未設定時は Supabase 通信が失敗するが、各 UI は error をハンドルして握りつぶす設計のため、
  // home などの静的ページは正常に表示され、Supabase 依存画面のみ機能が無効化される。
  console.warn(
    'Supabase env is missing. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (see .env.example). ' +
      'Supabase-dependent features will be disabled until these are configured.'
  );
}

// env 未設定でも createClient が throw しないよう、形式上有効なダミー URL/キーでフォールバックする。
// （空文字を渡すと createClient 自体が throw する場合があるため）。
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key'
);
